import React from "react";
import { useSelectedResult } from "../../../../contexts/SelectedResultContext";
import {
  deriveLdsOrderBusinessStatus,
  isPaidOrder,
  LDS_ORDER_BUSINESS_STATUS,
} from "../../../../utils/ldsOrderStatus";
import "./PackageBankTransferInstructions.scss";

/**
 * תוכן העברה בנקאית בלבד (ללא כפתורי CTA כפולים — ה־CTA נשאר בסיידבר/פוטר).
 */
const PackageBankTransferInstructions = ({ leftToPay, orderOverride = null, omitAmount = false }) => {
  const { ourSavedLDSOrder: ctxOrder } = useSelectedResult();
  const ourSavedLDSOrder = orderOverride ?? ctxOrder;
  const orderId = ourSavedLDSOrder?.id;
  const registered =
    deriveLdsOrderBusinessStatus(ourSavedLDSOrder) ===
    LDS_ORDER_BUSINESS_STATUS.WAITING_FOR_PAYMENT;
  const paid = isPaidOrder(ourSavedLDSOrder);

  const balance =
    leftToPay != null && leftToPay !== ""
      ? `₪${Number(leftToPay).toLocaleString()}`
      : null;

  return (
    <div className="package-bank-transfer-instructions">
      <p className="package-bank-transfer-instructions__lead">
        העברה בנקאית: לאחר יצירת ההזמנה יופיעו כאן או במייל הנחיות מספר הזמנה וסכום להעברה.
        האישור הסופי לחבילה יתבצע לאחר זיהוי התשלום במערכת.
      </p>
      {balance && !omitAmount ? (
        <p className="package-bank-transfer-instructions__amount">
          <span className="package-bank-transfer-instructions__amount-label">
            סכום לתשלום (כולל עמלת אשראי אם חויב):
          </span>{" "}
          <strong>{balance}</strong>
        </p>
      ) : null}
      {orderId && !registered && !paid ? (
        <p className="package-bank-transfer-instructions__draft-hint" role="note">
          לאחר אישור תנאי השימוש, לחצו על כפתור <strong>«קדימה לחופשה»</strong> בשורת
          הפעולות — ההזמנה תירשם כבקשת העברה בנקאית, ויוצגו מספר הזמנה והנחיות להשלמת
          התשלום.
        </p>
      ) : null}
      {registered && orderId && !paid ? (
        <div
          className="package-bank-transfer-instructions__status"
          role="status"
        >
          <p className="package-bank-transfer-instructions__status-title">
            ההזמנה נרשמה
          </p>
          <p>
            מספר הזמנה: <strong>{orderId}</strong>
          </p>
          <p className="package-bank-transfer-instructions__hint">
            לאחר ביצוע ההעברה נא לשמור אישור מהבנק. סטטוס ההזמנה יתעדכן אוטומטית לאחר
            זיהוי התשלום.
          </p>
        </div>
      ) : null}
    </div>
  );
};

export default PackageBankTransferInstructions;
